module.exports = __webpack_public_path__ + "img/eu3.20c9aa12.jpg";